module.exports = __webpack_public_path__ + "static/img/14000106.5e8fbe77.png";